import React from 'react';

import {
  Typography, makeStyles, createStyles,
} from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import Page from '../page/Page';
import GET_CATALOG_SPEC from '../../commons/gql/remote/catalogspecs/GetCatalogSpec';
import BasicsEditor from './components/editor/BasicsEditor';
import CoverWordsEditor from './components/editor/CoverWordsEditor';
import FeaturedProductsEditor from './components/editor/FeaturedProductsEditor';
import QuotesEditor from './components/editor/QuotesEditor';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
  inline: {
    display: 'inline-block',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

const CatalogSpecEditPage = () => {
  const { catalogSpecId } = useParams();
  const classes = useStyles();
  const { data: catalogSpecData, loading: loadingCatalogSpec } = useQuery(GET_CATALOG_SPEC, {
    variables: {
      catalogSpecId,
    },
  });

  if (loadingCatalogSpec) return <Page>Loading...</Page>;

  return (
    <Page>
      <Typography variant="h3" className={classes.header}>Catalog Spec Editor</Typography>
      <Typography variant="h5" className={classes.header}>Basics Editor</Typography>
      <BasicsEditor catalogSpec={catalogSpecData?.catalogSpec} onUpdate={() => {}} />
      <Typography variant="h5" className={classes.header}>Cover Words Editor</Typography>
      <CoverWordsEditor catalogSpec={catalogSpecData?.catalogSpec} onUpdate={() => {}} />
      <Typography variant="h5" className={classes.header}>Quotes Editor</Typography>
      <QuotesEditor catalogSpec={catalogSpecData?.catalogSpec} onUpdate={() => {}} />
      <Typography variant="h5" className={classes.header}>Featured Products Editor</Typography>
      <FeaturedProductsEditor catalogSpec={catalogSpecData?.catalogSpec} onUpdate={() => {}} />
    </Page>
  );
};

export default CatalogSpecEditPage;
